// the upload box and the compact file input.
import { $, $$, esc, icon } from './core.ts';

/** A file input this script already wrapped (the flag stops a second wrap). */
type WrappedInput = HTMLInputElement & { _dsFile?: boolean };

export function initUpload(): void {
  $$('.ds-drop').forEach(drop => {
    const input = $<HTMLInputElement>('input[type=file]', drop)!,
      list = document.getElementById(drop.dataset.list!),
      max = +(drop.dataset.maxBytes || 10485760),
      types = (drop.dataset.types || '').split(',').filter(Boolean);
    const kb = (n: number): string =>
      n > 1048576 ? (n / 1048576).toFixed(1) + ' مگابایت' : Math.max(1, Math.round(n / 1024)) + ' کیلوبایت';
    const show = (): void => {
      if (!list) return;
      list.innerHTML = [...input.files!]
        .map(f => {
          const ext = f.name.split('.').pop()!.toLowerCase(),
            why =
              types.length && !types.includes(ext)
                ? 'این نوع فایل پذیرفته نمی‌شود'
                : f.size > max
                  ? 'حجم فایل بیش از حد مجاز است'
                  : '';
          return `<div class="ds-file${why ? ' bad' : ''}"><span class="thumb">${icon(why ? 'alert' : 'file')}</span><span class="nm"><b>${esc(f.name)}</b><span>${why || kb(f.size)}</span></span><span></span></div>`;
        })
        .join('');
    };
    input.addEventListener('change', show);
    ['dragenter', 'dragover'].forEach(ev =>
      drop.addEventListener(ev, e => {
        e.preventDefault();
        drop.classList.add('over');
      }),
    );
    ['dragleave', 'drop'].forEach(ev => drop.addEventListener(ev, () => drop.classList.remove('over')));
    drop.addEventListener('drop', e => {
      e.preventDefault();
      input.files = e.dataTransfer!.files;
      show();
    });
  });
}
// T-072: a plain <input type="file"> (old forms) becomes the same drop box. The input itself stays (same id, name,
// accept and onchange), only wrapped; a dropped file is put into it and 'change' fired, so page handlers still run.
export function enhanceFile(input: WrappedInput | null | undefined): void {
  // .custom-file: a legacy page keeps its own; data-ds-plain: a page that opens the input itself (T-183: the ticket's paperclip)
  if (!input || input._dsFile || input.closest('.ds-drop, .custom-file') || input.hasAttribute('data-ds-plain')) return;
  input._dsFile = true;
  const drop = document.createElement('div');
  drop.className = 'ds-drop ds-drop-sm';
  input.parentNode!.insertBefore(drop, input);
  drop.insertAdjacentHTML(
    'beforeend',
    `<span class="ring">${icon('upload')}</span><b>فایل را اینجا رها کنید یا برای انتخاب بزنید</b><span data-ds-file-name>${input.multiple ? 'می‌توانید چند فایل انتخاب کنید' : 'هنوز فایلی انتخاب نشده'}</span>`,
  );
  drop.appendChild(input);
  input.classList.remove('form-control', 'custom-file-input');
  const name = $('[data-ds-file-name]', drop)!,
    empty = name.textContent;
  const show = (): void => {
    const fs = [...(input.files || [])];
    name.textContent = fs.length ? fs.map(f => f.name).join('، ') : empty;
    drop.classList.toggle('has', fs.length > 0);
  };
  input.addEventListener('change', show);
  ['dragenter', 'dragover'].forEach(ev =>
    drop.addEventListener(ev, e => {
      e.preventDefault();
      drop.classList.add('over');
    }),
  );
  ['dragleave', 'drop'].forEach(ev => drop.addEventListener(ev, () => drop.classList.remove('over')));
  drop.addEventListener('drop', e => {
    e.preventDefault();
    if (input.disabled) return;
    input.files = e.dataTransfer!.files;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
}
